var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tour',{attrs:{"name":_vm.tourName,"steps":_vm.steps,"options":_setup.OPTIONS},scopedSlots:_vm._u([{key:"default",fn:function(tour){return [_c(_setup.OnboardingStep,{staticClass:"mt-2",attrs:{"slot":"content","tour":tour,"tour-name":_vm.tourName},slot:"content"})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }